export enum NumberTypeEnum {
  ODD,
  EVEN,
}
